export const BRAND = {
  name: 'EVORA',
  handle: '@officialevoraclothing',
  tagline: 'Premium Fashion',
  instagram: 'https://www.instagram.com/officialevoraclothing',
  url: 'https://evoraclothing.com',
  /** Currency code for meta, structured data, analytics (e.g. INR, USD). */
  currency: 'INR',
  /** Locale for og:locale and Intl (e.g. en, en_IN). Use neutral 'en' for global. */
  locale: 'en',
};
